import SiteMenu from "../components/site-menu";
import components from "../components/_map";
import Utils from "../utils/utils";
import gsap from "gsap";
import { CustomEase } from "gsap/all";
import GridDebug from "../utils/gridDebug";
import EventEmitter from "eventemitter3";
import SmoothScroll from "../components/smooth-scroll";
import ScrollReveal from "../utils/scroll-reveal";
import SplitReveal from "../utils/split-reveal";
import Parallax from "../utils/parallax";
import NavTheme from "../utils/nav-theme";
import PageTransition from "../utils/page-transition";
import { markIntroStart, markSiteReady } from "../utils/site-ready";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(CustomEase, ScrollTrigger);

export default class AppController extends EventEmitter {
	constructor() {
		super();
		// Handling singleton creation
		if (!AppController.singleton) {
			// Storing the singleton instance
			AppController.singleton = this;
			this.components = [];
			this.navVisible = true
			this.gsap = gsap
			this.currentController = document.body.getAttribute('data-controller');
			this.components_map = components;
			// Returning the singleton
			this.init();
			this.gridDebug = new GridDebug();
			this.$menu = new SiteMenu(this);
			return AppController.singleton;
		}
	}
	init() {
		this.initAppEvents();
		this.initDomElements();
		this.$pageTransition = new PageTransition();
		this.instantiateComponents();

		document.addEventListener("meral:loader-complete", () => {
			this.$pageTransition?.reveal();
		}, { once: true });

		document.addEventListener("meral:transition-reveal-start", () => {
			markIntroStart();
		}, { once: true });

		document.addEventListener("meral:transition-revealed", () => {
			markSiteReady();
		}, { once: true });

		this.initViewportVhVar();
		this.initDetect();
		this.initTextareas();
		this.$scroll = new SmoothScroll();
		this.$reveal = new ScrollReveal();
		this.$splitReveal = new SplitReveal();
		this.$parallax = new Parallax();
		this.$navTheme = new NavTheme(this.$scroll);

		// Pas de loader ni de grille : intro immédiate
		if (!this.$pageTransition?.isCovered?.()) {
			markIntroStart();
			markSiteReady();
		}
	}
	initDomElements() {
		this.$site_container = document.querySelector('.site-container');
		this.$navbar = document.querySelector(".c-site-menu__container");
		this.$footer = document.querySelector('.c-site-footer');
		this.$buttons = document.querySelectorAll('.c-button');
	}
	initAppEvents() {

		window.onhashchange = () => {
			this.emit("hash-change", window.location.href);
		};

		window.addEventListener("scroll", (event) => {

			this.emit("scroll", event);
		})

		// Scroll events
		this.on("disable-scroll", () => {
			if (this.$scroll) {
				this.$scroll.disable();
			}
		});
		this.on("enable-scroll", () => {
			// enableBodyScroll(this.$site_container);
			if (this.$scroll) {
				this.$scroll.enable()
			}
		});
	}
	initTextareas() {
		const tx = document.getElementsByTagName("textarea");
		for (let i = 0; i < tx.length; i++) {
			tx[i].setAttribute("style", "height:" + (tx[i].scrollHeight) + "px;overflow-y:hidden;");
			tx[i].addEventListener("input", OnInput, false);
		}

		function OnInput() {
			this.style.height = "auto";
			this.style.height = (this.scrollHeight) + "px";
		}
	}

	instantiateComponents() {
		const components = document.body.querySelectorAll("[data-component]");
		for (let i = 0; i < components.length; i++) {
			const component = components[i];
			const name = component.getAttribute("data-component");
			if (this.components_map.hasOwnProperty(name)) {
				const componentClass = this.components_map[name];
				if (componentClass) {
					this.components.push(new componentClass.default(component));
				}
			}
		}
	}

	initViewportVhVar() {
		this.updateViewportVhVar();
		if (Utils.deviceType() == 'desktop') {
			window.addEventListener("resize", () => {
				this.updateViewportVhVar()
			});
		}
	}
	updateViewportVhVar() {
		let vh = window.innerHeight;
		document.documentElement.style.setProperty('--vh', `${vh / 100}px`);
	}

	initDetect() {
		window.addEventListener("resize", () => {
			this.detectDevice();
		});
		this.detectDevice();
	}
	detectDevice = () => {
		let landscape = window.matchMedia("(orientation: landscape)");
		document.documentElement.setAttribute('data-device-notice', Utils.deviceType() == 'mobile' && landscape.matches && window.innerWidth < 1000);
	}

	static getInstance() {
		return AppController.singleton;
	}
}
